import { ActionType, createAction } from 'typesafe-actions'

import { Dictionary } from '../../../utils/types'

import { Import } from './types'

export const ImportHistoryActions = {
  fetchData: createAction('IMPORT-HISTORY/load-data')<{
    page: number
    pageSize: number
    filter: string
  }>(),
  setData: createAction('IMPORT-HISTORY/set-data')<{
    page: number
    totalPages: number
    data: Import[]
  }>(),
  downloadExport: createAction('IMPORT-HISTORY/download-export')<{ exportId: string }>(),
  exportImports: createAction('IMPORT-HISTORY/export-reports')<{
    name: string
    columns: { id: string; label: string }[]
  }>(),
  setFilters: createAction('IMPORT-HISTORY/set-filters')<Dictionary<any>>(),
  clearFilter: createAction('IMPORT-HISTORY/clear-filter')<{ filterKey: string }>()
}

export type ImportHistoryActions = ActionType<typeof ImportHistoryActions>
